export enum LayerType {
  WMSLayer = 'WMS',
  WMTSServer = 'WMTS',
  WMTSLayer = 'WMTSLayer',
  FeatureLayer = 'FeatureLayer',
  FeatureServer = 'FeatureServer',
  MapImageLayer = 'MapImage',
  ImageryLayer = 'Imagery',
  TileLayer = 'Tile',
  VectorTileLayer = 'VectorTile',
  GraphicsLayer = 'GraphicsLayer'
}
